module.exports = __webpack_public_path__ + "static/media/greenhouse-part-3-header.2bc9b34d.jpg";